import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import CartFooter from '../comps/cartFooter.vue';
let DiscountPop = class DiscountPop extends Vue {
    constructor() {
        super(...arguments);
        this.show = false;
    }
    mounted() {
        this.show = true;
    }
    updateData(cartData) {
        this.$emit('updateData', cartData);
    }
    hide() {
        this.$emit('update:isDiscountPopShow', false);
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], DiscountPop.prototype, "isDiscountPopShow", void 0);
tslib_1.__decorate([
    Prop()
], DiscountPop.prototype, "cartData", void 0);
DiscountPop = tslib_1.__decorate([
    Component({
        components: {
            CartFooter,
        },
        filters: {
            number2Fixed: num => {
                const number = +num;
                return number ? `${number.toFixed(2)}` : '0.00';
            },
        },
    })
], DiscountPop);
export default DiscountPop;
